var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("TopNavigation", { attrs: { TopAct: "2" } }),
      _c(
        "div",
        { class: this.$store.state.webNavigator == "pc" ? "" : "" },
        [
          _c("listTopImg"),
          _c(
            "div",
            { staticClass: "max1720 marginAuto" },
            [
              _c("productPage", {
                attrs: { pageIndex: _vm.current },
                on: { getTotal: _vm.getTotal }
              }),
              _c("Pagination", {
                attrs: { total: _vm.total, "current-page": _vm.current },
                on: { pagechange: _vm.getPage }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-368491ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-368491ba","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productList/productList.vue
// module id = 1000
// module chunks = 12